import { Carousel } from "react-bootstrap";
import auth1 from "../assets/images/auth/auth-1.png";
import auth2 from "../assets/images/auth/auth-2.png";
import auth3 from "../assets/images/auth/auth-3.png";

const data = [
  {
    image: auth1,
    headingText: "Let Your Tools Do the Talking!",
    description:
      "Integrate, automate, and watch your sales team finally stop blaming the CRM!",
  },
  {
    image: auth2,
    headingText: "Trusted by the Best in Business!",
    description:
      "From startups to giants, they all swipe right on our automation magic!",
  },
  {
    image: auth3,
    headingText: "Automate Your Way to Success!",
    description:
      "From capturing leads to converting clients, our workflows do the heavy lifting while you focus on sealing the deal!",
  },
];

const AuthLeftContainer = () => {
  return (
    <div className="bg-theme font-roboto h-100 pb-5 px-5">
      <Carousel className="h-100" controls={false} interval={5000}>
        {data.map((d, i) => (
          <Carousel.Item key={i} className="h-100">
            <div className="d-none d-md-flex text-white flex-column align-items-center justify-content-center h-100">
              <div className="mb-4">
                <img
                  src={d.image}
                  style={{ width: "100%" }}
                  alt="Login Illustration"
                />
              </div>
              <div className="text-center heading24px fw-bold">
                {d.headingText}
              </div>
              <div className="heading14px text-center mw360">
                {d.description}
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default AuthLeftContainer;
